// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2oJvo","title":"Images90_title__1s3je","images":"Images90_images__3I83x"};